module.exports = __webpack_public_path__ + "img/3.b41b30fc.jpeg";